export default "/images/landscape.jpeg?34cb4b43ae58d7009d941be23eb3f01e";